import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const duplicateTemplate = (duplicateTemplateInfo: actionsInterfaces.DuplicateTemplateInfo, callback?: (result: any, error: any) => void): actionsInterfaces.IDuplicateTemplateAction => {
  return {
    type: actionsTypes.DUPLICATE_TEMPLATE,
    duplicateTemplateInfo,
    callback
  };
};

export const fetchTemplates = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchTemplatesAction => {
  return {
    type: actionsTypes.FETCH_TEMPLATES,
    query,
    callback
  };
};

export const fetchEveryTemplates = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchEveryTemplatesAction => {
  return {
    type: actionsTypes.FETCH_EVERY_TEMPLATES,
    query,
    callback
  };
};

export const addTemplate = (template: actionsInterfaces.ITemplate, callback: IAsyncActionCallback): actionsInterfaces.IPostTemplateAction => {
  return {
    type: actionsTypes.ADD_TEMPLATE,
    template,
    callback
  };  
};

export const setTemplates = (templates: actionsInterfaces.ITemplate): actionsInterfaces.ISetTemplatesAction => {
  return {
    type: actionsTypes.SET_TEMPLATE,
    templates,
  };
};

export const setEveryTemplates = (everyTemplates: actionsInterfaces.ITemplate[]): actionsInterfaces.ISetEveryTemplatesAction => {
  return {
    type: actionsTypes.SET_EVERY_TEMPLATE,
    everyTemplates,
  };
};

export const getTemplate = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchTemplateAction => {
  return {
    type: actionsTypes.GET_TEMPLATE_INFO,
    query,
    callback
  };  
};

export const setTemplate = (template: actionsInterfaces.ITemplate): actionsInterfaces.ISetTemplateAction => {
  return {
    type: actionsTypes.SET_TEMPLATE_INFO,
    template,
  };
};

export const addSuccess = (response: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS,
    response,
  };
};

export const fetchSearch = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchSearchAction => {
  return {
    type: actionsTypes.FETCH_SEARCH,
    query,
    callback
  };
};

export const setSearch = (searches: actionsInterfaces.ITemplate): actionsInterfaces.ISetSearchAction => {
  return {
    type: actionsTypes.SET_SEARCH,
    searches,
  };
};

export const updateTemplate = (template: actionsInterfaces.ITemplate, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateTemplateAction => {
  return {
    type: actionsTypes.UPDATE_TEMPLATE,
    template,
    callback
  };
};

export const fetchCounter = (filter?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchCounterAction => {
  return {
    type: actionsTypes.FETCH_COUNTER,
    filter,
    callback
  };
};

export const setCounter = (counter: actionsInterfaces.ITemplate): actionsInterfaces.ISetCounterAction => {
  return {
    type: actionsTypes.SET_COUNTER,
    counter,
  };
};


export const updateTemplates = (templates: actionsInterfaces.ITemplate[], callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateTemplatesAction => {
  return {
    type: actionsTypes.UPDATE_TEMPLATES,
    templates,
    callback
  };
};